module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/blog"
    }
  }, [_vm._v("Blog")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'EditBlogPost',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("Blog " + _vm._s(_vm.editing ? 'bewerken' : 'maken'))])], 1)]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.blog.title))]), _vm._v(" "), _c('div', [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blog.title),
      expression: "blog.title"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Blog Titel"
    },
    domProps: {
      "value": (_vm.blog.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blog, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blog.online),
      expression: "blog.online"
    }],
    staticClass: "uk-input uk-checkbox",
    attrs: {
      "type": "checkbox",
      "placeholder": "Beschikbaar"
    },
    domProps: {
      "checked": Array.isArray(_vm.blog.online) ? _vm._i(_vm.blog.online, null) > -1 : (_vm.blog.online)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.blog.online,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.blog.online = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.blog.online = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.blog, "online", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Openbaar")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory),
      expression: "newCategory"
    }],
    staticClass: "uk-select uk-form-width-medium",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.categories), function(c, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(c))])
  })), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addCategory($event)
      }
    }
  }, [_vm._v("toevoegen")])]), _vm._v(" "), (Object.keys(_vm.blog.categories).length > 0) ? _c('div', {
    staticClass: "uk-margin"
  }, _vm._l((_vm.blog.categories), function(c, k) {
    return _c('div', {
      staticClass: "uk-column-span"
    }, [_c('p', {
      staticClass: "uk-align-left"
    }, [_vm._v(_vm._s(c))]), _vm._v(" "), _c('button', {
      staticClass: "uk-align-right uk-label uk-label-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeCategory(k)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('Vueditor', {
    ref: "editor"
  })], 1), _vm._v(" "), _c('image-picker', {
    staticClass: "uk-margin-bottom",
    on: {
      "choose": _vm.choose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-child-width-1-4@m",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.blog.gallery), function(g, i) {
    return _c('div', [_c('div', {
      staticClass: "uk-card uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-media-top"
    }, [_c('img', {
      attrs: {
        "src": g.url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(g.description))])]), _vm._v(" "), _c('button', {
      staticClass: "uk-card-badge uk-label uk-label-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeImage(i)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })])])])
  })), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.editing ? 'updaten' : 'toevoegen'))])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fcd5114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/modules/BLOG/EditBlogPost.vue
// module id = 519
// module chunks = 1